import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Button} from 'views/components';
import {CheckCircle as CheckCircleIcon, Cancel as CancelIcon} from 'views/icons';
import {Translate, translate, SecureFileGrid} from 'views/module';

const CanadianIdView = (props) => {
  const {bioQuestions, setIsComplete} = props;

  const {
    hasId = false,
    hasBeenVerified = false,
    documents = [],
  } = bioQuestions?.canadianId || {};

  const [showDocuments, setShowDocuments] = React.useState(false);

  React.useEffect(() => {
    setIsComplete(hasBeenVerified);
  }, [hasBeenVerified, setIsComplete]);

  const renderStatusIcon = (value) =>
    value ? (
      <CheckCircleIcon sx={{color: 'success.main', fontSize: 22}} />
    ) : (
      <CancelIcon sx={{color: 'error.main', fontSize: 22}} />
    );

  const handleToggleDocuments = React.useCallback(() => {
    setShowDocuments((prev) => !prev);
  }, []);

  return (
    <Stack spacing={2} alignItems="flex-start" sx={{width: '100%'}}>
      {/* Has Check */}
      <Stack direction="row" spacing={1} alignItems="center">
        {renderStatusIcon(hasId)}
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression="caregiver.CaregiverBiography.CanadianId.HasCheck" />
        </Typography>
      </Stack>

      {/* Verified */}
      <Stack direction="row" spacing={1} alignItems="center">
        {renderStatusIcon(hasBeenVerified)}
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression="caregiver.CaregiverBiography.CanadianId.HasBeenVerified" />
        </Typography>
      </Stack>

      {/* Documents */}
      <Stack spacing={0.5} sx={{width: '100%'}}>
        <Typography variant="subtitle2" color="text.secondary">
          <Translate expression="caregiver.CaregiverBiography.CanadianId.Documents" />
        </Typography>

        {
          documents.length === 0 &&
          <Typography sx={{whiteSpace: 'pre-line'}} color="text.secondary">
            <Translate expression="caregiver.CaregiverBiography.CanadianId.EmptyState" />
          </Typography>
        }

        {
          documents.length > 0 &&
          <Stack spacing={0.5}>
            <Button
              variant="text"
              size="small"
              onClick={handleToggleDocuments}
              sx={{
                alignSelf: 'flex-start',
                padding: 0,
                textTransform: 'none',
                minHeight: 0,
                fontSize: '0.8rem',
                color: 'primary.main',
                fontWeight: 500,
              }}
            >
              {
                showDocuments ?
                translate('caregiver.CaregiverBiography.CanadianId.HideAttachments') :
                translate('caregiver.CaregiverBiography.CanadianId.ShowAttachments')
              }
            </Button>
            {
              showDocuments &&
              <SecureFileGrid files={documents} />
            }
          </Stack>
        }
      </Stack>
    </Stack>
  );
};

CanadianIdView.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  setIsComplete: PropTypes.func.isRequired,
};

export default React.memo(CanadianIdView);
